export default __webpack_public_path__ + "static/media/mashroom.923d33af.svg";